<template>
  <div>
    <template v-if="importantMessage">
      <template v-if="importantMessage.display === true">
        <div
            :class="['important', titleClass]"
        >
          {{importantMessage.title}}
        </div>
        <div style="text-align: center;">
          {{importantMessage.text}}
        </div>
        <br/>
      </template>
    </template>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  export default {
    name: 'home-important-message',
    async mounted() {
      await this.fetchConfigs();
    },
    computed: {
      importantMessage() {
        return this.$store.state.config.homePageImportantMessage;
      },
      titleClass() {
        if (this.importantMessage) {
          switch (this.importantMessage.type) {
            case 'normal_noir':
              return 'important__black';
            case 'avertissement_orange':
              return 'important__orange';
            case 'important_rouge':
              return 'important__red';
            case 'information_bleu':
              return 'important__bleu';
          }
        }
        return null;
      }
    },
    methods: {
      ...mapActions('config', {
        fetchConfigs: 'fetchConfigs'
      })
    }
  };
</script>

<style scoped lang="scss">
  .important {
    margin-top: 40px;
    margin-bottom: 10px;
    font-size: 1.35rem;
    text-align: center;

    &__red {
      color: red;
    }

    &__orange {
      color: orange;
    }

    &__black {
      color: black;
    }

    &__blue {
      color: #005eff;
    }

  }
</style>
